import { atom } from "recoil";

// 자동 채우기로 채운 칸 — 칸 위치 키(blockIndex-lineIndex-cellIndex) → 채운 값
export const autoFilledCellAtom = atom<Record<string, string>>({
  key: "autoFilledCellAtom",
  default: {},
});
